import React from "react";
import PredictionPage from "../../components/PredictionPage";

function Ripple() {
  return (
    <PredictionPage
      title="Ripple"
      content="This is the Ripple AI Trading Predictions page."
      canonical="/cryptocurrencies/ripple-ai-trading-predictions"
      categoryKey="nav.cryptocurrencies"
      categoryPath="/cryptocurrencies"
      symbol="RIPPLE"
    />
  );
}

export default Ripple;
